module.exports = __webpack_public_path__ + "static/media/nav_jj_plgd_bg.421ebab6.png";